<template>
  <v-container>
    <v-btn color="primary" outlined :to="{ name: 'AdminBranchCreate' }" router>
      Create Branch
    </v-btn>
    <v-divider class="my-4"></v-divider>
    <BranchListingComponent editPath="AdminBranchEdit"></BranchListingComponent>
  </v-container>
</template>

<script setup lang="ts">
import BranchListingComponent from '@/components/branches/BranchListingComponent.vue';
</script>

<style scoped></style>
